import styled from 'styled-components';
import { EIGHT, FOOTER_Z } from '../../const';
const pxPadding = `${EIGHT * 2}px`;
const FooterContainer = styled.div.withConfig({
  displayName: "FooterContainer",
  componentId: "sc-17s9z2i-0"
})(["position:fixed;bottom:0;left:", ";right:", ";padding-bottom:", ";z-index:", ";background:", ";"], p => p.hasIncreasedPadding ? '24px' : pxPadding, p => p.hasIncreasedPadding ? '24px' : pxPadding, p => p.hasIncreasedPadding ? '24px' : pxPadding, FOOTER_Z, ({
  theme
}) => theme.bento.colors.background.main);
export default FooterContainer;